import { render, staticRenderFns } from "./masterdebitur.vue?vue&type=template&id=5cc96238&"
import script from "./masterdebitur.vue?vue&type=script&lang=js&"
export * from "./masterdebitur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports